import structureTypes from 'common/constants/structureTypes'
import ServerPage from 'server/types/ServerPageInterface'
import { migrateCommand } from 'tools/commands/migrate/utils/migrateCommand'
import { migrateBulletList } from './migrateBulletList'

export default function (page: ServerPage): [ServerPage, boolean] {
  return migrateCommand({
    page,
    structureType: structureTypes.BULLET_LIST,
    migrateFunction: migrateBulletList,
  })
}
